/*
 * gsk-hero.js - Parallax-Scroll fuer den Hero-Hintergrund.
 * Spiegelt das CMS-Frontend (golfsimulator.kaufen): das Hero-Bild folgt dem
 * Scroll langsamer als der Vordergrund -> Tiefe. GPU-schonend (nur transform,
 * via requestAnimationFrame), und bei prefers-reduced-motion komplett aus
 * (dann bleibt der statische CSS-Transform).
 *
 * Der Basis-Offset (-31px) und scale stimmen mit .gsk-hero__bg in gsk-brand.css
 * ueberein; das JS ueberschreibt nur den translateY um den Parallax-Anteil.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // kein Parallax -> statischer CSS-Transform bleibt
  }

  var BASE_OFFSET = -31; // = --gsk-hero-bg-offset
  var FACTOR = 0.42; // Bg folgt mit 42% der Scrolldistanz (deutlich sichtbarer Parallax)
  var SCALE = 1.22; // Puffer, damit die Parallax-Verschiebung keine Kante zeigt

  function initHero(card) {
    if (!card || card.dataset.gskHeroParallax === 'true') return;
    card.dataset.gskHeroParallax = 'true';
    var bg = card.querySelector('.gsk-hero__bg');
    if (!bg) return;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = card.getBoundingClientRect();
      // nur rechnen, wenn der Hero im oder nahe am Viewport ist
      if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
      var scrolled = -rect.top; // > 0, sobald der Hero ueber den Viewport-Top wandert
      if (scrolled < 0) scrolled = 0;
      var y = BASE_OFFSET + scrolled * FACTOR;
      bg.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + SCALE + ')';
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initAll() {
    document.querySelectorAll('.gsk-hero__card').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify Theme-Editor: Section-Re-Render
  document.addEventListener('shopify:section:load', initAll);
})();
